/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelOutboundPhoneRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {CancelOutboundPhoneResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const cancelOutboundPhone = (request: CancelOutboundPhoneRequest, options?: CashRequestOptions) => post<CancelOutboundPhoneRequest, CancelOutboundPhoneResponse>("/cash-app/support-phone/cancel", request, {...options, rejectOnError: true })